module.exports = __webpack_public_path__ + "8914f6235f5b9908f596cb99e4b2438e.svg";